import { toast as reactToastify } from "react-toastify";
import { GlassmorphismToast } from "../components/GlassmorphismToast/GlassmorphismToast";

export const showToast = (message: string) => {
  reactToastify(
    ({ closeToast }) => (
      <GlassmorphismToast message={message} closeToast={closeToast} />
    ),
    {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: true,
    },
  );
};
